import React from "react";
import { Link } from "react-router-dom";
import { productImage } from "@/lib/imageUrl";

export const money = (c) => `$${((c || 0) / 100).toFixed(2)}`;

export function Badge({ tone = "navy", children }) {
  const map = { navy: "bg-[#0A192F] text-white", red: "bg-[#E63946] text-white", amber: "bg-amber-400 text-[#0A192F]", slate: "bg-slate-200 text-slate-600", green: "bg-emerald-500 text-white" };
  return <span className={`text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-sm ${map[tone]}`}>{children}</span>;
}

export function ProductCard({ p }) {
  const soldOut = p.availability === "sold_out";
  return (
    <Link to={`/marketplace/product/${p.slug}`} data-testid={`product-card-${p.slug}`}
      className="group block bg-white border border-slate-200 rounded-sm overflow-hidden hover:shadow-lg hover:border-slate-300 transition-all">
      <div className="relative aspect-square bg-slate-50 overflow-hidden">
        <img src={productImage(p.thumbnail_url)} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        <div className="absolute top-2 left-2 flex flex-col gap-1 items-start">
          {p.on_sale && <Badge tone="red">Sale</Badge>}
          {p.new_arrival && <Badge tone="green">New</Badge>}
          {p.limited_edition && <Badge tone="amber">Limited</Badge>}
          {p.availability === "preorder" && <Badge tone="navy">Preorder</Badge>}
          {p.fulfillment_model === "made_to_order" && <Badge tone="slate">Made to Order</Badge>}
        </div>
        {soldOut && <div className="absolute inset-0 bg-white/70 grid place-items-center"><Badge tone="slate">Sold Out</Badge></div>}
      </div>
      <div className="p-3">
        <div className="text-sm font-semibold text-[#0A192F] leading-tight line-clamp-2 min-h-[2.5rem]">{p.name}</div>
        <div className="mt-1.5 flex items-center gap-2">
          <span className="font-data text-[#0A192F]">{money(p.price_cents)}{p.price_max_cents > p.price_cents ? "+" : ""}</span>
          {p.compare_at_cents && <span className="text-xs text-slate-400 line-through">{money(p.compare_at_cents)}</span>}
        </div>
      </div>
    </Link>
  );
}
